import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { subscribe } from 'react-contextual'
import ErrorBoundary from '@argos/error-boundary'

import { MegaMenuCategories } from '../../components'
import { NavigationStore } from '../../stores'

import styles from './MegaMenu.scss'

export class MegaMenu extends React.Component {
  static propTypes = {
    activeCategory: PropTypes.shape({
      index: PropTypes.number,
      title: PropTypes.string,
      link: PropTypes.string,
    }),
    focusedItem: PropTypes.number,
    menuToggled: PropTypes.bool,
    onSetRef: PropTypes.func,
    onToggleCategoryFocus: PropTypes.func,
    onUpdateActiveCategory: PropTypes.func,
    onUpdateActiveMenu: PropTypes.func,
    shopAllRef: PropTypes.shape({
      current: PropTypes.string,
    }),
    taxonomy: PropTypes.arrayOf(
      PropTypes.shape({
        link: PropTypes.string,
        title: PropTypes.string,
        columns: PropTypes.arrayOf(
          PropTypes.arrayOf(
            PropTypes.shape({
              title: PropTypes.string,
              links: PropTypes.arrayOf(
                PropTypes.shape({
                  link: PropTypes.string,
                  title: PropTypes.string,
                }),
              ),
            }),
          ),
        ),
      }),
    ),
  }

  static defaultProps = {
    taxonomy: [],
    activeCategory: {
      index: null,
      title: null,
      link: null,
    },
    menuToggled: false,
    focusedItem: null,
    shopAllRef: null,
    onSetRef: () => {},
    onUpdateActiveMenu: () => {},
    onUpdateActiveCategory: () => {},
    onToggleCategoryFocus: () => {},
  }

  constructor(props) {
    super(props)
    this.MegaMenuComponent = null
    this.state = {
      lazyLoaded: false,
    }
  }

  async componentWillReceiveProps(nextProps) {
    if (!this.state.lazyLoaded && nextProps.menuToggled) {
      try {
        this.MegaMenuComponent = await import('../../components/MegaMenu/MegaMenu')
        this.setState({ lazyLoaded: true })
      } catch (e) {
        console.warn('Loadable error: ', e)
      }
    }
  }

  buildMenu() {
    let Component = MegaMenuCategories /* fallback to just showing l1 categories */

    if (this.state.lazyLoaded) {
      Component = this.MegaMenuComponent.default /* otherwise, show lazy loaded megamenu with sub cats */
    }

    return (
      <Component
        taxonomy={this.props.taxonomy}
        activeCategory={this.props.activeCategory}
        focusedItem={this.props.focusedItem}
        isFallbackMenu={!this.state.lazyLoaded}
        shopAllRef={this.props.shopAllRef}
        onSetRef={this.props.onSetRef}
        onUpdateActiveMenu={this.props.onUpdateActiveMenu}
        onUpdateActiveCategory={this.props.onUpdateActiveCategory}
        onToggleCategoryFocus={this.props.onToggleCategoryFocus}
      />
    )
  }

  render() {
    const MegaMenuComponent = this.buildMenu()
    const { title, index, link } = this.props.activeCategory
    const submenuActive = title
    const submenuActiveNoContent = !title && (index && link)
    const boxShadow = !submenuActive || submenuActiveNoContent === this.props.taxonomy.length ? true : null

    return (
      <Fragment>
        <ul
          id='megaMenu'
          aria-labelledby='ShopLink'
          className={styles.megaMenu}
          data-submenu-active={submenuActive}
          data-submenu-active-no-content={submenuActiveNoContent}
          data-box-shadow={boxShadow}
          role='menubar'>
          {this.props.menuToggled ? MegaMenuComponent : null}
        </ul>
      </Fragment>
    )
  }
}

const SubscribedComponent = subscribe([NavigationStore], (navigation) => ({
  menuToggled: navigation.menuToggled,
  focusedItem: navigation.focusedItem,
  activeCategory: navigation.activeCategory,
}))(subscribe()(MegaMenu))

const ProvidedComponent = (props) => (
  <ErrorBoundary>
    <SubscribedComponent {...props} />
  </ErrorBoundary>
)

export default ProvidedComponent
